import { useIntelligenceKpis } from "../hooks/use-intelligence-queries.ts";

function formatBillions(n: number): string {
  if (n >= 1e9) return `$${(n / 1e9).toFixed(2)}B`;
  if (n >= 1e6) return `$${(n / 1e6).toFixed(1)}M`;
  if (n >= 1e3) return `$${(n / 1e3).toFixed(0)}K`;
  return `$${n.toFixed(0)}`;
}

export function KpiStrip() {
  const { data, isLoading, error } = useIntelligenceKpis();

  if (isLoading) return <div className="intel-kpi-strip intel-kpi-strip--loading">Loading…</div>;
  if (error || !data)
    return <div className="intel-kpi-strip intel-kpi-strip--error">Failed to load KPIs</div>;

  const items = [
    { label: "Projects tracked", value: data.totalProjects.toLocaleString() },
    { label: "Capital tracked", value: formatBillions(data.totalCommittedCapitalUsd) },
    { label: "With funding", value: data.projectsWithFunding.toLocaleString() },
    { label: "Median raise", value: formatBillions(data.medianRaiseUsd) },
    {
      label: "Approaching TGE",
      value: data.approachingTge.toLocaleString(),
    },
  ];

  return (
    <div className="intel-kpi-strip">
      {items.map((item) => (
        <div className="intel-kpi-cell" key={item.label}>
          <div className="intel-kpi-value">{item.value}</div>
          <div className="intel-kpi-label">{item.label}</div>
        </div>
      ))}
    </div>
  );
}
